//Servicios
import httpClientePublicoCore from '../../Servicios/httpClientePublicoCore';

// Se encacarga de obtener el token de un cliente especifico
//CustomerId: Identificador del cliente
export const obtenerTokenCustomer = (registro) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post("/CIFInfo/TokenCliente/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};